import Loading from '../../../../shared/Loading/Loading';
import Header from './Header';
import Row from './Row';

const Table = ({
  loading,
  filteredInteractions,
  displayedInteractions,
  query,
  mode,
  editable,
  editedScores,
  loadingUpdate,
  handleScoreChange,
  sortConfig,
  handleSort,
  stickyOffset,
}) => {
  if (mode === 'modal' || mode === 'resume') return null;

  return (
    <div
      className={`hidden md:block ${mode === 'resume' ? 'pb-3' : ''}`}
      style={{ overflowX: 'clip' }}
    >
      {loading ? (
        <div className="flex justify-center py-10">
          <Loading size="28" colorBase="white" colorAccent="personalized" double={true} bold="8" />
        </div>
      ) : filteredInteractions.length === 0 ? (
        <div className="text-center text-sm text-gray-500 py-6">
          {mode === 'resume'
            ? 'No hay actividades realizadas actualmente'
            : query ? `No hay coincidencias para "${query}"` : 'No hay interacciones disponibles'}
        </div>
      ) : (
        <table className="min-w-full table-fixed divide-y divide-gray-200">
          <Header
            mode={mode}
            loadingUpdate={loadingUpdate}
            sortConfig={sortConfig}
            handleSort={handleSort}
            stickyOffset={stickyOffset}
          />
          <tbody className="bg-white">
            {displayedInteractions.map((interaction, index) => (
              <Row
                key={index}
                interaction={interaction}
                mode={mode}
                editable={editable}
                editedScores={editedScores}
                loadingUpdate={loadingUpdate}
                handleScoreChange={handleScoreChange}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Table;
